/**
 * Device Events Service
 *
 * Handles device events: events list, water events, unit day duration, usage time.
 * Single entry for /api/sw/device_events and related endpoints.
 */

import { apiClient } from './apiClient';
import buildParams from '../utils/params';

/**
 * Get device events (paginated).
 */
export const getDeviceEvents = async (
  mac_address,
  page = 1,
  pageSize = 10,
  extraParams = {},
) => {
  const params = {
    mac_address,
    ...buildParams(extraParams, page, pageSize),
  };
  const response = await apiClient.get('/api/sw/device_events/', { params });
  return response.data;
};

/**
 * Get water events (paginated).
 */
export const getWaterEvents = async (
  device_id,
  page = 1,
  pageSize = 10,
  extraParams = {},
) => {
  const params = buildParams(extraParams, page, pageSize, device_id);
  const response = await apiClient.get('/api/sw/device_events/water-events/', { params });
  return response.data;
};

/**
 * Get a single device event by ID.
 */
export const getDeviceEvent = async (event_id) => {
  const response = await apiClient.get(`/api/sw/device_events/${event_id}/`);
  return response.data;
};

/**
 * Get detailed water event by metric_id.
 */
export const getWaterEvent = async (metric_id) => {
  const response = await apiClient.get('/api/sw/device_events/detailed-water-change/', {
    params: { metric_id },
  });
  return response.data;
};

/**
 * Get latest unit day duration for a device.
 */
export const getLatestUnitDayDuration = async (device_id) => {
  const response = await apiClient.get('/api/sw/device_events/latest-unit-day-duration', {
    params: { device_id },
  });
  return response.data;
};

/**
 * Get total recorded usage time in the current day.
 */
export const getTotalUsageTimeToday = async (deviceId) => {
  const response = await apiClient.get('/api/sw/device_events/last-active-usage/', {
    params: { device_id: deviceId },
  });
  return response.data;
};
